import { LocationsSpaceOccupant } from '@centecomm/portal-service';
import { useLocations } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LocationsActions, LocationsActionTypes } from '../actions';
import * as selectors from '../selectors';

type SpacesFromStateHook = (
    propertyId: number | string,
    spaceId: number | string,
) => {
    areLoaded: boolean;
    spaceOccupants: LocationsSpaceOccupant[];
};

const useLocationsSpaceOccupantsFromState: SpacesFromStateHook = (propertyId: number | string, spaceId: number | string) => {
    const dispatch = useDispatch();
    const { getOccupantsOfSpace } = useLocations();

    const areLoaded: boolean = useSelector(selectors.occupantsLoadedForSpace(spaceId));
    const spaceOccupants: LocationsSpaceOccupant[] = useSelector(selectors.spaceOccupants(spaceId));

    React.useEffect(() => {
        if (!areLoaded) {
            getOccupantsOfSpace(+propertyId, +spaceId).then((occupantsResponse: LocationsSpaceOccupant[]) => {
                dispatch({
                    type: LocationsActions.ADD_SPACE_OCCUPANTS,
                    payload: {
                        spaceId,
                        occupants: occupantsResponse,
                    },
                } as LocationsActionTypes);
            });
        }
    }, [areLoaded]);

    return {
        areLoaded,
        spaceOccupants,
    };
};

export default useLocationsSpaceOccupantsFromState;
